<template>
  <div>
    <!-- <div class="animated fadeIn card p-4 mt-0 pb-0 mb-0 history"> -->
      <!-- <div class="form-group row">
        <div class="col-md-12 text-left">
          <h6 class="text-third text-bold"><i class="fas fa-stream"></i> AÇÕES</h6>
        </div>
      </div> -->
      <!-- <div class="form-group row flex-grow-1"> -->
        <div class="timeline__container">
        <b-tabs class="" pills card>
          <b-tab title="Follow-Up">
            <div class="time-scroll">
              <div v-if="followup === null || followup.length === 0"
                class="d-flex h-100 align-items-center justify-content-center">
                <span>Nenhum registro foi encontrado.</span>
              </div>
              <div v-else v-for="action in followup" :key="action.id" class="timeline">
                <div class="w-100 d-flex">
                  <div class="timeline-type">
                    <b-avatar v-if="action.eventoDTO && action.eventoDTO.deslocamento === true"
                      variant="primary">
                      <i class="fas fa-tachometer-alt"/>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_agendamento'"
                      variant="primary">
                      <i class="fas fa-calendar-alt" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_email_enviado'"
                      variant="primary">
                      <i class="fas fa-envelope-open-text" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_ligacao'" variant="primary">
                      <i class="fas fa-headset" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_produto_adicionado'"
                      variant="primary">
                      <i class="fas fa-plus" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_produto_excluido'"
                      variant="primary">
                      <i class="fas fa-minus" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_produto_liquidado'"
                      variant="primary">
                      <i class="fas fa-minus" />
                    </b-avatar>
                    <b-avatar v-else
                      variant="primary">
                      <i class="fas fa-calendar-alt" />
                    </b-avatar>
                  </div>
                  <div class="d-flex flex-column justify-content-center pr-4 w-100">
                    <div class="d-flex justify-content-between">
                      <div>
                        <i class="fas fa-calendar" />&nbsp;
                        {{ moment.tz(action.data, 'America/Sao_Paulo').format('DD/MM/YY HH:mm') }}
                      </div>
                      <div>
                        <i class="fas fa-user" />&nbsp;
                        {{ action.autor }}
                      </div>
                    </div>
                    <div class="d-block">
                      <i class="fas fa-plus-square" />&nbsp;
                      {{ action.eventoDTO.nome }}
                    </div>
                  </div>
                </div>
                <div class="px-4 pb-2">
                  <hr class="mb-2 mt-0" />
                  <div class="d-flex justify-content-between">
                    <span class="text-bold">Descrição:</span>
                    <span v-if="action.despesas && action.despesas.length > 0" class="text-bold">
                      Total Despesa: {{ somaValorDespesas(action.despesas) }}
                    </span>
                  </div>
                  <span class="text-justify timeline-description" v-html="action.detalhes"></span>
                  <div v-if="action.arquivo && action.arquivo.length > 0" class="d-flex">
                    <span class="text-bold">Anexos:&nbsp;</span>
                    <span class="text-bold">
                      <span
                        style="cursor: pointer;"
                        v-for="(attach, index) in action.arquivo"
                        :key="index"
                        v-b-tooltip.hover
                        :title="attach.nomeOriginal"
                        @click="onDownloadFile(action, attach)"
                      >
                        <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
                      </span>
                    </span>
                  </div>
                  <div v-if="action.despesasFiles && action.despesasFiles.length > 0" class="d-flex">
                    <span class="text-bold">Anexos Despesa:&nbsp;</span>
                    <span class="text-bold">
                      <span
                        style="cursor: pointer;"
                        v-for="(attach, index) in action.despesasFiles"
                        :key="index"
                        v-b-tooltip.hover
                        :title="attach.nomeOriginal"
                        @click="onDownloadFileDespesa(action, attach)"
                      >
                        <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Promessas" v-if="isBoardCobranca" @click="abrirModalPromessas">
            <div class="d-flex h-100 align-items-center justify-content-center">
              <span class="text-muted">
                <i class="fas fa-handshake fa-2x"></i>
              </span>
            </div>
          </b-tab>
          <b-tab title="Histórico">
            <div class="time-scroll">
              <div v-if="history === null || history.length === 0"
                class="d-flex h-100 align-items-center justify-content-center">
                <span>Nenhum registro foi encontrado.</span>
              </div>
              <div v-else v-for="action in history" :key="action.id" class="timeline">
                <div class="w-100 d-flex">
                  <div class="timeline-type">
                    <b-avatar v-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_atualizacao_cadastral'"
                      variant="info">
                      <i class="fas fa-user-edit" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_telefone_adicionado'"
                      variant="info">
                      <i class="fas fa-phone-volume"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_endereco_adicionado'"
                      variant="info">
                      <i class="fas fa-map-marker-alt"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_responsavel_adicionado'"
                      variant="info">
                      <i class="fas fa-user-tie"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_nova_oportunidade'"
                      variant="primary">
                      <i class="fas fa-user"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_oportunidade_perdida'"
                      variant="danger">
                      <i class="fas fa-heart-broken"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_oportunidade_reativada'"
                      variant="warning">
                      <i class="fas fa-sync"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_oportunidade_excluida'"
                      variant="danger">
                      <i class="fas fa-user-slash"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_oportunidade_ganha'"
                      variant="success">
                      <i class="fas fa-dollar-sign" />
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_oportunidade_finalizada'"
                      variant="warning">
                      <i class="fas fa-check"></i>
                    </b-avatar>
                    <b-avatar v-else-if="action.eventoDTO && action.eventoDTO.mnemonic === 'sys_card_movido'"
                      variant="info">
                      <i class="fas fa-exchange-alt" />
                    </b-avatar>
                    <b-avatar v-else-if="!action.hasOwnProperty('eventoDTO')"
                      variant="info">
                      <i class="fas fa-comment-dots" />
                    </b-avatar>
                    <b-avatar v-else variant="info">
                      <i class="fas fa-headset" />
                    </b-avatar>
                  </div>
                  <div class="d-flex flex-column justify-content-center pr-4 w-100">
                    <div class="d-flex justify-content-between">
                      <div>
                        <i class="fas fa-calendar" />&nbsp;
                        {{ moment.tz(action.data, 'America/Sao_Paulo').format('DD/MM/YY HH:mm') }}
                      </div>
                      <div>
                        <i class="fas fa-user" />&nbsp;
                        {{ action.autor }}
                      </div>
                    </div>
                    <div>
                      <i class="fas fa-plus-square" />&nbsp;
                      <p class="my-0 d-inline" v-if="!action.hasOwnProperty('eventoDTO')">Observação</p>
                      <p class="my-0 d-inline" v-else>{{ action.eventoDTO ? action.eventoDTO.nome : '' }}</p>
                    </div>
                  </div>
                </div>
                <div class="px-4 pb-2">
                  <hr class="mb-2 mt-0" />
                  <div class="d-flex justify-content-between">
                    <span class="text-bold">Descrição:</span>
                    <span v-if="action.despesas && action.despesas.length > 0" class="text-bold">
                      Total Despesa: {{ somaValorDespesas(action.despesas) }}
                    </span>
                  </div>
                  <span class="text-justify timeline-description" v-html="action.detalhes"></span>
                  <div v-if="action.arquivo && action.arquivo.length > 0" class="d-flex">
                    <span class="text-bold">Anexos:&nbsp;</span>
                    <span class="text-bold">
                      <span
                        style="cursor: pointer;"
                        v-for="(attach, index) in action.arquivo"
                        :key="index"
                        v-b-tooltip.hover
                        :title="attach.nomeOriginal"
                        @click="onDownloadFile(action, attach)"
                      >
                        <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
                      </span>
                    </span>
                  </div>
                  <div v-if="action.despesasFiles && action.despesasFiles.length > 0" class="d-flex">
                    <span class="text-bold">Anexos Despesa:&nbsp;</span>
                    <span class="text-bold">
                      <span
                        style="cursor: pointer;"
                        v-for="(attach, index) in action.despesasFiles"
                        :key="index"
                        v-b-tooltip.hover
                        :title="attach.nomeOriginal"
                        @click="onDownloadFile(action, attach)"
                      >
                        <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
        </div>
      <!-- </div> -->
    <!-- </div> -->

    <!-- Modal de Promessas -->
    <ModalPromessas
      ref="modalPromessas"
      :cardId="cardId"
      v-on:promessa-atualizada="onPromessaAtualizada"
    />
  </div>
</template>
<script>
import CrmDetailsTimeline from './timeline.js'
export default CrmDetailsTimeline
</script>
<style>
li.nav-item{
  margin-right: .5rem;
}
</style>
<style scoped>
/* .history {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  } */

.time-scroll {
  overflow-y: auto;
  @media screen and (max-width: 480px) {
    max-height: 60vh;
  }
}

.timeline {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 8px;
  margin-top: 7px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.11);
}

.timeline-type {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 98px;
  max-width: 98px;
  padding: 10px;
  margin-right: 0px;
  text-align: center;
}

.timeline-history {
  flex-grow: 1;
  font-size: 12px;
  padding: 12px 15px 15px 5px;
  text-align: justify;
  vertical-align: middle;
}

.timeline-date {
  font-size: 11px;
  text-align: center;
  padding-top: 5px;
}

.timeline-user {
  font-size: 11px;
}

.timeline-description {
  width: 100%;
  display: block;
  position: relative;
  background-color: #fafafa;
  padding: 15px;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/timeline/timeline.vue